import { Routes } from '@angular/router';
import { TwoColumnsRightComponent } from '../upgrade/main.template.directive';
import {
  EmailTypesComponent,
  EmailTypeComponent,
  EmailLogsComponent,
  EmailTemplateComponent
} from '../upgrade/email-types.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import { authGuard, forceOnlineGuard } from '@fry-it/risr-core';
import { unsavedGuard } from '@fry/upgrade/unsaved.guard';

export const emailsRoutes: Routes = [
  {
    path: 'emails',
    component: TwoColumnsRightComponent,
    canActivate: [setupGuard, authGuard, forceOnlineGuard],
    data: {
      permission: 'emailTemplates.view'
    },
    children: [
      {
        path: '',
        component: EmailTypesComponent,
        data: {
          state: 'epf.email-templates.index'
        }
      },
      {
        path: 'log',
        component: EmailLogsComponent,
        canActivate: [authGuard],
        data: {
          permission: 'emailTemplates.view',
          state: 'epf.email-templates.email-logs'
        }
      },
      {
        path: 'log_booking',
        component: EmailLogsComponent,
        canActivate: [authGuard],
        data: {
          permission: 'emailTemplates.view',
          state: 'epf.email-templates.email-logs-booking'
        }
      },
      {
        path: ':emailTypeId',
        component: EmailTypeComponent,
        data: {
          state: 'epf.email-templates.view'
        }
      },
      {
        path: ':emailTypeId/log',
        component: EmailLogsComponent,
        canActivate: [authGuard],
        data: {
          permission: 'emailTemplates.view',
          state: 'epf.email-templates.type-log'
        }
      },
      {
        path: ':emailTypeId/:emailTemplateId',
        component: EmailTemplateComponent,
        canActivate: [authGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'emailTemplates.edit',
          state: 'epf.email-templates.template'
        }
      },

    ]
  }
];
